// lib
import railsPostFetch from '@aytm/lib/common/rails-post-fetch'
import { call, delay } from 'redux-saga/effects'

// stores
import staticStore from '@aytm/app/insights/dashboard/stores/static.store'

export default function* updateTitleSaga(title) {
  if (!staticStore.canUpdateDashboard) {
    return null
  }
  const updateTitleURL = staticStore.urls.updateTitle
  if (!updateTitleURL) {
    throw new Error('No "updateTitle" endpoint URL')
  }
  for (let i = 0; i < 5; i++) {
    try {
      const response = yield call(railsPostFetch, updateTitleURL, {
        body: JSON.stringify({
          survey_id: staticStore.dashboardID,
          title
        })
      })
      if (!response.ok) {
        throw new Error(response.error || 'Error updating title')
      }
      const body = yield call([response, 'json'])
      return body.status ? body?.data?.title : null
    } catch {
      if (i < 4) {
        yield delay(1500)
      }
    }
  }
  throw new Error('Error updating title after multiple attempts')
}
